import React from 'react'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { defaultProps } from './index'

export const ListIconBoxSettings = (props) => {

  return (
    <>
      <div className="empty-message">
        <p>No options available</p>
      </div>
    </>
  );
};
